import React from "react";
import { Table } from "antd";
import { SafeCellContent } from "../../../../../../util/SafeCellContent";

class EditableTable extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         loading: this.props.loadingPage,
         columns: this.props.columns,
         dataSource: this.props.rows,
      };
   }

   // dataSource comes with object in fields sometimes. Antd table cant display object`s, so we extract value from those objects
   transformDataSource = (data) => {
      return data.map((item) => {
         const transformedItem = {};
         for (const key in item) {
            if (item.hasOwnProperty(key)) {
               if (
                  item[key] !== null &&
                  typeof item[key] === "object" &&
                  item[key].hasOwnProperty("value")
               ) {
                  transformedItem[key] = item[key].value;
               } else {
                  transformedItem[key] = item[key];
               }
            }
         }
         return transformedItem;
      });
   };

   componentDidUpdate(prevProps) {
      if (prevProps.loadingPage !== this.props.loadingPage) {
         this.setState({ loading: this.props.loadingPage });
      }
      if (prevProps.columns !== this.props.columns) {
         this.setState({ columns: this.props.columns });
      }
      if (prevProps.rows !== this.props.rows) {
         // This is fired when rows change, so we change loading status to false
         this.setState({ dataSource: this.props.rows, loading: false });
      }
   }

   render() {
      const { dataSource, columns, loading } = this.state;

      const safeColumns = (columns ?? []).map((col) =>
         col?.render
            ? col
            : {
                 ...col,
                 render: (value) => <SafeCellContent content={value} />,
              },
      );

      return (
         <>
            <Table
               dataSource={this.transformDataSource(dataSource)}
               columns={safeColumns}
               scroll={{ x: true }}
               pagination={false}
               bordered
               size="middle"
               loading={loading}
            />
         </>
      );
   }
}

export default EditableTable;
